<template>
  <b-container fluid class="bg-white">
    <div class="row" style="background-color: rgba(255, 255, 255, 0.5)">
      <div class="col-lg lizard-form-empty-col"></div>
    </div>
    <div class="row align-items-center py-2 mb-4 switcher-container">
      <div class="col-3 text-left pl-3">
        <b-button
          variant="outline-primary"
          size="sm"
          class="btn-switcher px-3 py-2"
          @click="prevWeek()"
          v-if="!loading"
        >
          <b-icon icon="chevron-left" class="mr-2"></b-icon>
          Previous Week
        </b-button>
      </div>
      <div class="col-6 text-center">
        <div
          class="month-display d-flex align-items-center justify-content-center"
          @click="goToCurrentWeek()"
          v-if="!loading"
          style="cursor: pointer"
          title="Go to current week"
        >
          <b-icon
            icon="calendar3"
            class="mr-2 text-primary"
            font-scale="1.1"
          ></b-icon>
          <span class="month-title">{{ monthInfo }}</span>
        </div>
        <div class="month-display text-muted" v-else>
          <b-spinner small class="mr-2" type="grow"></b-spinner>
          Loading, Please wait...
        </div>
      </div>
      <div class="col-3 text-right pr-3">
        <b-button
          variant="outline-primary"
          size="sm"
          class="btn-switcher px-3 py-2"
          @click="nextWeek()"
          v-if="!loading"
        >
          Next Week
          <b-icon icon="chevron-right" class="ml-2"></b-icon>
        </b-button>
      </div>
    </div>
    <div class="row" style="background-color: rgba(255, 255, 255, 0.5)">
      <div class="col-lg lizard-form-empty-col"></div>
    </div>
    <div class="row lizard-calendar">
      <div class="col-lg-12 lizard-calendar-holder">
        <h6>
          <b-badge pill variant="light" style="color: #999"
            >* If you don't see any staffed projects in the list, please ask the
            admin team to activate the project.</b-badge
          >
        </h6>
        <TwoWeeksCalendarTimelog
          :loading="loading"
          :projects="projects"
          :timelogs="timelogs"
          :showWeekends="showWeekends"
          :_fn_runTimelogQueue="runTimelogQueue"
          :_fn_getPreviousWeekTimelogs="getPreviousWeekTimelogs"
        />
      </div>
    </div>
    <div class="row" style="background-color: rgba(255, 255, 255, 0.5)">
      <div class="col-lg lizard-form-empty-col"></div>
    </div>
    <div class="row" style="background-color: rgba(255, 255, 255, 0.5)">
      <div class="col-lg lizard-form-empty-col"></div>
    </div>
  </b-container>
</template>

<script>
import { format as dateFormat, sub, add, differenceInDays } from 'date-fns'
import ServicesOld from '../../services/index.vue'
import Services from '../../services/main.service.vue'
import TwoWeeksCalendarTimelog from './Timelogs/Calendar.vue'

export default {
  name: 'TimeLogs',
  components: {
    TwoWeeksCalendarTimelog
  },
  computed: {
    Store() {
      return this.$store.getters
    },
    calendarWeeksStartDate() {
      return this.Store.calendarWeeksStartDate
    },
    monthInfo() {
      return this.Store.timelogMonthInfo
    },
    logsInQueue() {
      return this.Store.timelogsInQueue
    },
    logsToRemoveQueue() {
      return this.Store.timelogsToRemoveQueue
    }
  },
  data() {
    return {
      showSaveTooltip: false,
      showWeekends: true,
      projects: [],
      assignments: [],
      timelogs: [],
      loading: false,
      dataFetched: false,
      editMode: false,
      savingMode: false
    }
  },
  mounted() {
    this.$store.commit('setTimelogCalendarWeeksStartDate', null)
    this.tabMounted()
  },
  methods: {
    tabMounted() {
      // this.setDefaultCalendarWeeksStartDate()
      this.currentWeek()
      // this.getProjects()
      // setTimeout(this.prevWeek, 500)
      // setTimeout(this.refreshData, 600)
    },
    prevWeek() {
      this.$store.commit(
        'setTimelogCalendarWeeksStartDate',
        sub(new Date(this.calendarWeeksStartDate), {
          weeks: 1
        })
      )
      this.currentWeek()
    },
    nextWeek() {
      this.$store.commit(
        'setTimelogCalendarWeeksStartDate',
        add(new Date(this.calendarWeeksStartDate), {
          weeks: 1
        })
      )
      this.currentWeek()
    },
    goToCurrentWeek() {
      this.setDefaultCalendarWeeksStartDate()
      this.setCurrentMonth(false)
    },
    currentWeek() {
      let getPrevWeek = false
      if (!this.calendarWeeksStartDate) {
        this.setDefaultCalendarWeeksStartDate()
        getPrevWeek = true
      }
      this.setCurrentMonth(getPrevWeek)
    },
    setDefaultCalendarWeeksStartDate(setNull = false) {
      if (setNull) {
        this.$store.commit('setTimelogCalendarWeeksStartDate', null)
      } else {
        this.$store.commit('setTimelogCalendarWeeksStartDate')
      }
    },
    setCurrentMonth(getPrevWeek = false) {
      if (getPrevWeek) {
        return this.prevWeek()
      }
      const now = new Date()
      const startDate = this.calendarWeeksStartDate
      const isCurrentWeek = this.isWithinTwoWeeks(now, startDate)
      const monthsDays = this.countDaysByMonth(startDate)
      const selectedMonth = this.getFirstMonthWithMinDays(monthsDays, 7)
      const selectedYear = isCurrentWeek
        ? this.getYear(now)
        : this.getYear(startDate)
      this.$store.commit(
        'setTimelogMonthInfo',
        selectedMonth + ' ' + selectedYear
      )
      this.getUserTimelogs()
      // this.editMode = false
      // this.clearChangeQueues(false, true)
    },
    toggleEditMode() {
      this.editMode = !this.editMode
      this.clearChangeQueues()
    },
    clearChangeQueues(updTls = true, delTls = true) {
      if (updTls) {
        this.$store.commit('clearTimelogQueue')
      }
      if (delTls) {
        this.$store.commit('clearDeleteTimelogQueue')
      }
    },
    async refreshData() {
      // this.$root.$emit('week-changed-on-timelogs')
      // await this.getUserTimelogs()
      // await this.getUserAssignments()
      // this.dataFetched = true
    },
    queueIterator(queue, idx = 0) {
      return {
        next() {
          const result = queue[idx]
          idx += 1
          return {
            value: result,
            done: !result
          }
        }
      }
    },
    submitChanges() {
      this.savingMode = true
      this.submitLogs()
      this.deleteLogs()
      this.savingMode = false
      setTimeout(() => {
        this.loading = true
        this.editMode = false
        this.refreshData()
      }, 500)
    },
    submitLogs() {
      const itr = this.queueIterator(this.logsInQueue)
      let next = itr.next()
      while (!next.done) {
        this.updateTimelog(next.value)
        next = itr.next()
      }
      if (next.done) {
        this.$store.commit('clearTimelogQueue')
      }
    },
    deleteLogs() {
      const itr = this.queueIterator(this.logsToRemoveQueue)
      let next = itr.next()
      while (!next.done) {
        this.removeTimelog(next.value)
        next = itr.next()
      }
      if (next.done) {
        this.$store.commit('clearDeleteTimelogQueue')
      }
    },
    async getProjects() {
      this.loading = true
      const { status, data } = await Services.Projects.getList({})
      this.loading = false
      if (status == 200) {
        this.projects = data.content
          .map((prj) => {
            const prjType =
              prj.type === 'business_development' ? 'BD' : 'Project'
            if (prjType === 'BD') {
              const hasBDPerfix = /^BD/.test(prj.title)
              if (!hasBDPerfix) {
                prj.title = `BD ${prj.title}`
                if (prj.client) {
                  prj.title = `${prj.title} (${prj.client})`
                }
              }
            }
            return prj
          })
          .sort((a, b) => {
            if (a.title < b.title) return -1
            if (a.title > b.title) return 1
            return 0
          })
      }
    },
    async getUserAssignments() {
      this.loading = true
      if (!this.calendarWeeksStartDate) {
        this.setDefaultCalendarWeeksStartDate()
      }
      const { status, data } = await ServicesOld.GetStaffingAssignmentsByUser({
        fromDate: dateFormat(this.calendarWeeksStartDate, 'yyyy-MM-dd')
      })
      if (status == 200) {
        this.assignments = data.content
      }
      this.loading = false
    },
    async getUserTimelogs() {
      this.loading = true
      if (!this.calendarWeeksStartDate) {
        this.setDefaultCalendarWeeksStartDate()
      }
      const { status, data } = await ServicesOld.GetTimeLogs({
        dates: {
          from: dateFormat(new Date(this.calendarWeeksStartDate), 'yyyy-MM-dd'),
          to: dateFormat(
            add(new Date(this.calendarWeeksStartDate), {
              days: 13
            }),
            'yyyy-MM-dd'
          )
        }
      })
      if (status == 200) {
        this.timelogs = data.content
        this.getProjects()
      }
      this.loading = false
    },
    async getPreviousWeekTimelogs() {
      if (!this.calendarWeeksStartDate) {
        this.setDefaultCalendarWeeksStartDate()
      }
      const start = sub(new Date(this.calendarWeeksStartDate), { weeks: 1 })
      const { status, data } = await ServicesOld.GetTimeLogs({
        dates: {
          from: dateFormat(start, 'yyyy-MM-dd'),
          to: dateFormat(add(start, { days: 6 }), 'yyyy-MM-dd')
        }
      })
      if (status == 200) {
        return data.content
      }
      return []
    },
    async updateTimelog({ project: projectUid, date, hours }) {
      if (hours > 24) {
        this.$bvToast.toast('You can not log more than 24 hours per day', {
          title: 'Error',
          variant: 'danger',
          solid: true
        })
        return
      }
      const { status } = await ServicesOld.AddTimelog({
        projectUid,
        date,
        hours
      })
      return { status }
    },
    async removeTimelog({ project: projectUid, date }) {
      this.loading = true
      const { status } = await ServicesOld.RemoveTimelog({
        projectUid,
        date
      })
      this.loading = false
      return { status }
    },
    isWithinTwoWeeks(date1, date2) {
      const diffInDays = differenceInDays(add(date2, { days: 13 }), date1)
      return diffInDays > 0 && diffInDays < 14
    },
    countDaysByMonth(startDate) {
      const monthsDays = {}
      const start = new Date(startDate)
      const end = add(new Date(startDate), { days: 13 })

      const loopDate = new Date(start)
      while (loopDate <= end) {
        const month = this.getMonthName(loopDate)
        monthsDays[month] = (monthsDays[month] || 0) + 1
        loopDate.setDate(loopDate.getDate() + 1)
      }

      return monthsDays
    },
    getFirstMonthWithMinDays(monthsDays, minDays) {
      for (const month in monthsDays) {
        if (monthsDays[month] >= minDays) {
          return month
        }
      }
      return null
    },
    getMonthName(date) {
      try {
        return dateFormat(date, 'MMMM')
      } catch (error) {
        console.error({ error })
        return null
      }
    },
    getYear(date) {
      try {
        return dateFormat(date, 'yyyy')
      } catch (error) {
        console.error({ error })
        return null
      }
    },
    runTimelogQueue() {
      const items = Object.assign([], this.logsInQueue)
      if (!items.length) return
      this.loading = true
      this.updateTimelog(items[0])
        .then((res) => {
          this.loading = false
          if (res.status == 200) {
            this.$store.commit('removeTimelogFromQueue', items[0])
          }
        })
        .catch((error) => {
          this.$bvToast.toast('Failed to update timelog, please try again!', {
            title: 'Error',
            variant: 'danger',
            solid: true
          })
          this.$store.commit('removeTimelogFromQueue', items[0])
          this.loading = false
        })
    }
  },
  watch: {
    logsInQueue() {
      setTimeout(this.runTimelogQueue, 1500)
    },
    logsToRemoveQueue() {
      setTimeout(this.deleteLogs, 1500)
    }
  }
}
</script>

<style>
.lizard-calendar {
  /* overflow: hidden !important; */
  margin: 0 auto !important;
  padding: 0 !important;
}
.lizard-calendar > .lizard-calendar-holder {
  margin: 0 auto !important;
  padding: 0 !important;
}
.container-fluid.lizard-no-padding {
  padding-right: 0 !important;
}
.row.lizard-no-margin {
  margin-right: 0 !important;
}
</style>

<style scoped>
.switcher-container {
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.02);
  border: 1px solid rgba(0, 0, 0, 0.04);
}
.btn-switcher {
  border-radius: 8px !important;
  font-weight: 600 !important;
  font-size: 0.75rem !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  min-width: 150px;
  transition: all 0.2s ease !important;
}
.month-display {
  padding: 5px;
}
.month-title {
  font-size: 1.25rem !important;
  font-weight: 700 !important;
  color: #0073be !important;
  letter-spacing: -0.01em;
}
.hours-controllers {
  padding: 0 10px;
  margin: 0;
  text-align: right;
}
.hours-controllers ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.hours-controllers ul li {
  display: inline-block;
  margin: 0 1px;
}
.hours-controllers .lizard-hour-controller-btn {
  color: #fff;
  margin: 0;
  width: 100%;
  height: 40px;
  line-height: 30px;
  min-width: 140px !important;
  max-width: 100px !important;
  padding: 5px;
  text-align: center;
  font-size: 9pt;
  font-weight: bold;
  background-color: #999;
  text-transform: uppercase;
  border-radius: 3px;
}
.hours-controllers .lizard-hour-controller-btn.is-active {
  background-color: #333;
}
.hours-controllers .lizard-hour-controller-btn.current-week {
  max-width: 100px !important;
  height: auto !important;
  margin: 0 auto !important;
}
.hours-controllers .lizard-hour-controller-btn:hover {
  background-color: #000;
  color: #fff;
  cursor: pointer;
}
.hours-controllers .lizard-hour-controller-btn:active {
  background-color: #000;
  color: #ccc;
}
</style>
